import logo from './logo.svg';
import './App.css';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Contact } from './components/Contact';
import { Guestbook } from './components/Guestbook';
import 'bootstrap/dist/css/bootstrap.min.css';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <Contact />
      <Guestbook />
      </LanguageProvider>
    </div>
  );
}

export default App;
